import useCollection from '../competition-info/submission/hooks/useCollection'

const DESCRIPTION_PDF_FIELD = 'f9669a88-d8aa-4c60-b8a7-cd0211221723'

const initialData = {
  completeProposals: {},
  descriptionPdfUrls: {},
  boardsData: {}
}

function normalizeKey(value) {
  return typeof value === 'string' ? value.trim().toLowerCase() : ''
}

function getPdfDownloadUrl(pdfField) {
  if (!pdfField) {
    return ''
  }

  if (typeof pdfField === 'string') {
    return pdfField
  }

  if (Array.isArray(pdfField)) {
    return getPdfDownloadUrl(pdfField[0])
  }

  return (
    pdfField.downloadUrl ||
    pdfField.downloadURL ||
    pdfField.url ||
    getPdfDownloadUrl(pdfField.file) ||
    ''
  )
}

function addUrlKeys(map, url, ...keys) {
  keys.forEach(key => {
    const normalized = typeof key === 'string' ? key.trim() : ''
    if (normalized && url) {
      map[normalized] = url
      map[normalizeKey(normalized)] = url
    }
  })
}

export function getDescriptionPdfUrl(descriptionPdfUrls, proposal, proposalId) {
  const keys = [
    proposalId,
    proposal && proposal.proposalId,
    proposal && proposal.name,
    proposal && proposal.pseudonym
  ]

  for (let i = 0; i < keys.length; i++) {
    const key = keys[i]
    if (!key) {
      continue
    }

    const url = descriptionPdfUrls[key] || descriptionPdfUrls[normalizeKey(key)]
    if (url) {
      return url
    }
  }

  return ''
}

export default function useSubmittedProposals() {
  const { documents } = useCollection('sub-b-proposals')

  if (!documents) {
    return initialData
  }

  const completeProposals = Object.entries(documents)
    .filter(([, doc]) => doc.proposalStatus === 'completed')
    .map(([id, doc]) => ({ ...doc, id }))

  const descriptionPdfUrls = {}
  Object.entries(documents).forEach(([id, doc]) => {
    const downloadUrl = getPdfDownloadUrl(doc[DESCRIPTION_PDF_FIELD])
    addUrlKeys(
      descriptionPdfUrls,
      downloadUrl,
      id,
      doc.id,
      doc.proposalId,
      doc.pseudonym
    )
  })

  const boardsData = completeProposals.map(doc => ({
    id: doc.id,
    pseudonym: doc.pseudonym,
    board: doc.board
  }))

  const excelData = completeProposals.map(doc => ({
    id: doc.id,
    pseudonym: doc.pseudonym,
    excel: doc['82dcf484-26d4-41fb-b80b-d143c790c155']
  }))

  const modalData = completeProposals.map(doc => ({
    id: doc.id,
    pseudonym: doc.pseudonym,
    modal: doc['c2fe7c34-6500-4681-9f1c-b3efa63d8387']
  }))

  const imagesData = completeProposals.map(doc => ({
    id: doc.id,
    pseudonym: doc.pseudonym,
    aerialView: doc['2dd54880-8404-432e-a80f-a78e54054962'],
    view1: doc['874d730d-d9e0-4282-add8-ec1f62cb054e'],
    view2: doc['ba84f1b9-d833-49b2-9b1f-aa5c6c1215be']
  }))

  const authorData = completeProposals.map(doc => ({
    id: doc.id,
    pseudonym: doc.pseudonym,
    author: doc['1bdde5b0-9d7b-495f-aa4d-65a33780b206']
  }))

  return {
    completeProposals,
    descriptionPdfUrls,
    boardsData,
    excelData,
    modalData,
    imagesData,
    authorData
  }
}
